import { defineStore } from 'pinia'
import _ from 'lodash';
export const useLanguageStore = defineStore('LanguageStore', {
    state: () => (
        {
            locale: "en",
            translations: {},
            possible: [],
            loaded: false,
            addNew: false,
            list: [],
            infinity: {
                active: false,
                columns: ["name"],
            },
            allLoaded: false,
        }),
    getters: {

        getLanguageByKey: (state) => (key) => {
            var index = state.list.findIndex(item => item.key == key);
            if (index > -1) {
                return state.list[index];
            }
            return { name: "", key: "", value: "" };
        },
    },
    actions: {
        setLocale(locale){
            localStorage.setItem("_locale", locale);
            this.locale = locale;
            this.loaded = false;
        },
        __(key, para) {
            if (_.has(this.translations, key)) {
                var string = _.get(this.translations, key);
                if (para != undefined) {
                    var data = Object.keys(para);
                    for (let i = 0; i < data.length; i++) {
                        if (para[data[i]] == null || para[data[i]] == undefined || para[data[i]] == NaN) {
                            para[data[i]] = "";
                        }
                        string = string.replace("%%" + data[i] + "%%", para[data[i]]);
                    }
                }
                return string;
            }
            return key;
        },
        async load() {
            await axios.get("/api/v1/language", { params: { locale: this.locale } }).then((response) => {
                this.translations = response.data.data;
                this.locale = response.data.locale;
                this.loaded = false;
                this.possible = response.data.available;
                this.loaded = true;
            })
        },
        async tracking_translations() {
            await axios.get("language/tracking", { params: { locale: this.locale } }).then((response) => {
                this.translations = response.data.data;
                this.locale = response.data.locale;
                this.loaded = false;
                this.possible = response.data.available;
                this.loaded = true;
            })
        },
        async loadLanguages(data) {
            await axios.get("/api/v1/getLanguages").then(response => {
                let newList = response.data;
                    if (newList == undefined || newList.length <= 0) {
                        this.allLoaded = true;
                        }
                        if (this.infinity.active == true) {
                        this.list.push(...newList);
                        } else {
                        this.list = newList;
                        }
            })
        },

        clean() {
            this.list = [];
            this.allLoaded = false;
            this.loaded = false;
        },
    },
})
